'use client';

import { ActionIcon, NavLink } from '@mantine/core';
import Logout from '@material-design-icons/svg/filled/logout.svg';

import { useLogout } from '@/hooks';

import styles from './LogoutButton.module.css';

interface LogoutButtonProps {
  onLoggedOut?: () => void;
  onlyUseIcon?: boolean;
}

const LogoutButton: React.FC<LogoutButtonProps> = ({
  onLoggedOut,
  onlyUseIcon = true,
}) => {
  const { initiateLogout } = useLogout(onLoggedOut);

  return (
    <>
      {onlyUseIcon ? (
        <ActionIcon
          variant="subtle"
          onClick={initiateLogout}
        >
          <Logout />
        </ActionIcon>
      ) : (
        <NavLink
          label="Logout"
          onClick={initiateLogout}
          className={styles.navLink}
          rightSection={<Logout className={styles.logoutIcon} />}
        />
      )}
    </>
  );
};

export { LogoutButton };
